<template>
  <section id="pepite-section">
    <h1 class="title">{{$resx('PepiteOfTheWeekText')}}</h1>
    <h2 class="subtitle">{{$resx('PepiteSubtitleText')}}</h2>
    <div class="args text-center">
      <div class="args-content">
        <h3>{{$resx('PepiteArgumentsTitleText')}}</h3>
        <ul>
          <li><i>&#10004;</i>{{$resx('PepiteFirstArgumentText')}}</li>
          <li><i>&#10004;</i>{{$resx('PepiteSecondArgumentText')}}</li>
          <li><i>&#10004;</i>{{$resx('PepiteThirdArgumentText')}}</li>
          <li><i>&#10004;</i>{{$resx('PepiteFourthArgumentText')}}</li>
        </ul>
      </div>
    </div>
    <span class="choice text-center">{{$resx('PepiteChoiceText')}}</span>
    <table class="mytable">
      <thead>
        <tr>
          <th>{{$resx('PepiteTableHeader1Text')}}</th>
          <th>{{$resx('PepiteTableHeader2Text')}}</th>
          <th v-html="$resx('PepiteTableHeader3Text')"></th>
          <th>{{$resx('PepiteTableHeader4Text')}}</th>
          <th v-html="$resx('PepiteTableHeader5Text')"></th>
          <th>{{$resx('PepiteTableHeader6Text')}}</th>
          <th>{{$resx('PepiteTableHeader7Text')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="week in pepiteWeeks" :key="week.id">
          <td>{{week.week}}<span>{{$resx('FromDateToDateText', [week.formatedStartDate, week.formatedEndDate])}}</span></td>
          <td>{{week.period}}</td>
          <td>{{week.formatedNbDisplays}}</td>
          <td>
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" :style="{fill:week.pack.color}">
              <path d="M5509.57,2760.33c-1.1-.95-1.96-1.69-2.41-2.14a5.365,5.365,0,0,0-3.41-1.19,5.039,5.039,0,0,0-2.25.54c-0.26.14-.56,0.28-0.89,0.44-1.88,1.01-5.04,2.5-5.24,4.05l-0.06.44c-0.31,2.22-.96,6.97,1.6,8.3,3.44,1.83,12.74,2.84,14.03,1.83a12.566,12.566,0,0,0,3.01-6.81v0.04a2.569,2.569,0,0,0-.49-2.06C5512.24,2762.62,5510.66,2761.27,5509.57,2760.33Z" transform="translate(-5495 -2757)" />
            </svg>
            {{week.pack.name}}
          </td>
          <td v-if="week.discountRatio !== null"><strike class="default-price">{{week.pack.formatedPrice}}</strike>{{week.formatedDiscountPrice}}</td>
          <td v-else>{{week.pack.formatedPrice}}</td>
          <td v-if="week.isAvailable" class="dispo">{{$resx('YesText')}}</td>
          <td v-if="!week.isAvailable" class="no-dispo">{{getNoDispoText(week)}}</td>
          <td><a v-if="week.isAvailable" @click="selectWeek(week)">{{$resx('PepiteTableChooseText')}}</a></td>
        </tr>
      </tbody>
      <tfoot v-if="isLoading">
        <tr>
          <td colspan="8" class="text-center">
            <i class="loading material-icons">cached</i>
          </td>
        </tr>
      </tfoot>
    </table>
    <modal class="modal-pepite" v-if="this.selection.displayModal" :isLoading="this.selection.step===2" @close="hideSelectWeekModal">
      <h3 slot="header">{{$resx('PepiteOfTheWeekText')}}</h3>
      <div slot="body">
        <span class="subtitle">{{$resx('PepitePopChooseWeekText')}}</span>
        <div v-if="this.selection.step===1">
          <h4 v-html="$resx('PepitePopConfirmYourWeekText',[selection.week.week])"></h4>
          <div class="flex">
            <button class="btn btn-primary btn-rounded" @click="confirmWeek"><b>{{$resx('YesText')}}</b><span v-html="$resx('PepitePopConfirmChoiceText')"></span></button>
            <button class="btn btn-primary btn-rounded" @click="hideSelectWeekModal"><b>{{$resx('NoText')}}</b><span v-html="$resx('PepitePopCancelChoiceText')"></span></button>
          </div>
          <p class="warning" v-html="$resx('PepitePopWarningText',[selection.week.formatedBestPrice])"></p>
        </div>
        <div v-if="this.selection.step===3">
          <div class="congrats">{{$resx('PepitePopCongratulationsText')}}</div>
          <p class="confirmation" v-html="getConfirmationText()"></p>
          <button class="btn btn-primary" @click="hideSelectWeekModal">{{$resx('PepitePopChooseAnotherWeekText')}}</button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import modal from '../components/modal.vue'
import pepiteServices from '../services/pepiteServices'

export default {
  data () {
    return {
      selection:
      {
        displayModal: false,
        step: 1,
        week: {}
      },
      pepiteWeeks: [],
      isLoading: false
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  methods: {
    // clic sur une semaine pour la choisir
    selectWeek (week) {
      this.selection.displayModal = true
      this.selection.week = week
    },

    // confirmer le choix d'une semaine
    confirmWeek () {
      var self = this
      this.selection.step = 2

      pepiteServices.book(this.currentCampingId, this.selection.week.id)
        .then(response => {
          self.selection.step = 3
          self.loadWeeks()
        })
        .catch(error => {
          self.selection.step = 1
          this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },

    // ferme la fenetre modale de choix de semaine
    hideSelectWeekModal () {
      this.selection =
      {
        displayModal: false,
        step: 1,
        week: { }
      }
    },

    // affiche "non" si pas dispo ou le nom du camping si c'est son camping
    getNoDispoText (week) {
      if (week.booker !== undefined && week.booker !== null) {
        return week.booker
      }
      return this.$resx('NoText')
    },

    // retourne le message de confirmation
    getConfirmationText () {
      const html = this.$resx('PepitePopConfirmation1Text', [this.selection.week.week]) + '<i class="period">' +
        this.$resx('FromDateToDateText', [this.selection.week.formatedStartDate, this.selection.week.formatedEndDate]) + '</i>' +
        this.$resx('PepitePopConfirmation2Text', [this.$store.state.partner.account.currentCamping.name])

      return html
    },

    // charge la liste des semaines
    loadWeeks () {
      var self = this
      this.pepiteWeeks = []
      this.isLoading = true
      pepiteServices.loadList()
        .then(response => {
          self.isLoading = false
          self.pepiteWeeks = response
        })
        .catch(error => {
          self.isLoading = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    }
  },
  components:
  {
    modal: modal
  },
  mounted: function () {
    this.$store.commit('app/setPage', 'pepite')
    this.loadWeeks()
  }
}
</script>

<style lang="less">
@import '../assets/variables.less';

  .modal-pepite
  {
    h3
    {
      font-family: 'Playfair Display', serif;
    }

    .modal-container
    {
      max-width: 64em;
      text-align:center;
    }

    .subtitle {
      display: block;
      color:@gold;
      font-size: 1.5em;
      font-weight: @fontBlack;
      text-transform: uppercase;
    }
    h4 {
      font-size: 2em;
      font-weight: @fontBold;
    }

    .btn {
      width: 45%;
      padding-top: 2em;
      padding-bottom: 2em;
      font-weight: @fontBlack;
      text-align:center;

      b
      {
        display:block;
        font-size:2em;
        margin-bottom:.25em;
      }
      small {
        font-weight: @fontBold;
        font-size:.9em;
      }
    }

    .warning {
      display:block;
      margin-top:2.5em;
      color: @grey9;

      b
      {
        display:block;
        color: @white;
        font-weight: @fontBold;
      }

      strong
      {
        color:@gold;
      }
    }

    .congrats
    {
      font-weight:@fontBlack;
      font-size:3em;
      margin:1em auto;
    }
   .confirmation {
      font-weight: @fontBold;
      font-size:1.5em;
      line-height:1.25em;

      .period
      {
        display:block;
        margin-top:1em;
        font-style: normal;
        font-weight: @fontRegular;
        color: @grey9;
      }

      b
      {
        color:@gold;
      }
    }
}
</style>

<style lang="less">
  @import '../assets/variables.less';

  #pepite-section
  {

  .args {
    margin: 2em auto;

    h3
    {
      font-size: 1.5em;
      font-weight: @fontBlack;
      color: @grey9;
      text-transform: uppercase;
      text-align: center;
    }

    .args-content
    {
      display:inline-block;
      margin:auto;
    }

    ul
    {
      text-align:left;
    }

    li
  {
    margin: 1em 0;
    color: black;
    font-weight: @fontBold;
    font-size: 1.1em;
  }

    i
    {
      color:@gold;
      margin-right:1em;
    }
  }

  .choice
  {
    display:block;
    color:@grey9;
    font-weight:@fontBlack;
    font-size:3em;
    padding-bottom:1em;
  }

  table {
    thead
    {

      th
      {

        &:nth-child(1)
        {
          width:9em;
        }
        &:nth-child(2) {
          width:auto;
        }
        &:nth-child(3) {
          max-width: 8em;
        }
        &:nth-child(4) {
          min-width: 8em;
          max-width:10em;
        }
        &:nth-child(5) {
          max-width: 7em;
        }

        i
        {
          display:block;
          font-style:normal;
          font-size:.8em
        }
      }
    }

    tbody
    {
      td {
        svg
        {
          width:19px;
          margin-right:1em;
        }

        &:nth-child(1)
        {
          span
          {
            display:block;
            font-weight:@fontRegular;
            font-size:.8em;
          }
        }
        &:nth-child(3)
        {
          text-align:center;
        }
        &:nth-child(5) {
          text-align: right;
        }
        &:nth-child(6) {
          text-align: center;
        }
        &.dispo {
          background-color: #43a047;
          color:@white;
        }

        &.no-dispo {
          background-color: #e53935;
        }

        .default-price{
          margin-right:1em;
        }
      }
    }
  }
  }
</style>
